import React from "react";
import Navbar from "./navbar/Navbar";
import { Link } from "react-router-dom";

class NotFound extends React.Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="not-found full-page d-flex justify-content-center align-items-center">
          <div>
            <div>
              <p className="message-404 has-text-centered">404</p>
            </div>

            <div className="title has-text-center mt-4">
              Oooops! You Missed!
            </div>

            <div className="has-text-centered mt-4">
              <Link to="/">
                <button className="button is-info">Go Back Home</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;
